module.exports = __webpack_public_path__ + "img/fake_pic.195ffad3.png";